import styled from 'styled-components';
/**
 * Оборачивающий компонент для пагинации точками.
 * Стилизованный компонент, обладающий всеми свойствами ``div``.
 */

import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('PaginationDots/PaginationDots');
export var PaginationDots = /*#__PURE__*/styled.ul.attrs(function (_ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? 'true' : _ref$ariaHidden;
  return {
    'aria-hidden': ariaHidden
  };
}).withConfig({
  componentId: "plasma__sc-p8lg6o-0"
})(["display:flex;flex-wrap:wrap;align-self:center;align-items:center;margin:0;padding:0;list-style:none;"]);